import { render, staticRenderFns } from "./CompanyRevenueSummary.vue?vue&type=template&id=cdb22b36"
import script from "./CompanyRevenueSummary.vue?vue&type=script&lang=js"
export * from "./CompanyRevenueSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports